import React from 'react'
import { useState, useRef, useEffect, useLayoutEffect } from "react";
import SearchResult from './SearchResult';
import SearchBox from './SearchBox';
import SearchPanelFilterSwitch from './SearchPanelFilterSwitch';


export default function SearchPanel(props) {

    const [searchResultHeight, setSearchResultHeight] = useState(0);
    const [searchconditionHeight, setSearchconditionHeight] = useState(0);

    const searchPanelContainerRef = useRef(null);
    const searchConditionRef = useRef(null);
    const searchResultRef = useRef(null);
   
    useLayoutEffect(() => {
        // 検索結果一覧の高さを再計算
        if (searchConditionRef.current && searchResultRef.current) {
            let margin = 0;
            if(props.isMobileMode){
                if(props.showHeader){
                    margin = 51;
                }else{
                    margin = 1;
                }
            }else{
                if(props.showHeader){
                    margin = 81;
                }else{
                    margin = 31;
                }
            }
            setSearchResultHeight(
                (props.height - searchConditionRef.current.clientHeight - margin) + 'px'
            );
        }
        
    }, [props.height, props.isMobileMode,props.searchPanelVisible,props.items]); //ウィンドウ高さが変わったとき

    useEffect(() => {
        // スクロール位置をリセット
        if (searchResultRef.current) {
            searchResultRef.current.scrollTop = 0;
        }
    }, [props.items]);  //検索結果の内容が変わったとき

    useEffect(() => {
        //パネルサイズの変化
        if(!props.isShowSearchResultPanel){
            setSearchconditionHeight(searchConditionRef?.current?.clientHeight+ 'px');
        }
    }, [props.filters]);  //フィルタが変わったとき

    function getContainerSize() {
        var height = 0;
        if(props.isMobileMode){
            if(props.showHeader){
                height = 50;
            }else{
                height = 0;
            }
        }else{
            if(props.showHeader){
                height = 80;
            }else{
                height = 30;
            }
        }
        if(props.isShowSearchResultPanel){
            height = "calc(100% - " + height + "px)" ;
        }else{
            height = searchconditionHeight;
        }
        
        return {
            width: props.width > 400 ? "400px" : props.width + "px",
            height:  height,
            top:props.showHeader ? 50 : 0
        };
    }

    return (
        <div className="searchpanel-container" ref={searchPanelContainerRef} style={getContainerSize()}>

            <div className={"searchpanel-background " + (props.searchPanelVisible ? "searchpanel-background-appear" : "")} />
            <div className="searchpanel">
                <div className="searchcondition" ref={searchConditionRef}>
                    <div className="searchbox-container">
                        <SearchBox
                            keyword={props.keyword}
                            isSearching={props.isSearching}
                            searchPanelVisible={props.searchPanelVisible}
                            onToggleClick={props.onToggleClick}
                            onSearchClick={props.onSearchClick}
                            onChangeKeyword={props.onChangeKeyword}
                            onClearClick={props.onClearClick}
                        />
                    </div>
                    <SearchPanelFilterSwitch
                                userAuthorities={props.userAuthorities}
                                keyword={props.keyword}
                                targetTypes={props.filters.type}
                                filters={props.filters}
                                isMobileMode={props.isMobileMode}
                                width={props.width}
                                height={props.height}
                                onSearchFilterClick={props.onSearchFilterClick}
                                updateShowFiltersInfo={props.updateShowFiltersInfo}
                                viewtype={props.viewtype}
                                searchPanelVisible={props.searchPanelVisible}
                                
                                onSearch={props.onSearch}
                                onApplyFilter={props.onApplyFilter}
                                onApplyFilter_date={props.onApplyFilter_date}
                                onApplyFilter_noSearch = {props.onApplyFilter_noSearch}
                                onSearchOptionClick={props.onSearchOptionClick}
                            />

                </div>
                {props.isShowSearchResultPanel &&
                    <div className={"searchpanel-collapsed " + (props.searchPanelVisible ? "searchpanel-visible" : "")}>
                        <div className="sr-line"></div>
                        <div className="sr-items" ref={searchResultRef} style={{ height: searchResultHeight }}>
                            <SearchResult
                                beforeSearch={props.beforeSearch}
                                items={props.items}
                                allCount={props.allCount}
                                onEnterItem={props.onEnterItem}
                                onLeaveItem={props.onLeaveItem}
                                onEnterImg={props.onEnterImg}
                                onLeaveImg={props.onLeaveImg}
                                onTagClick={props.onTagClick}
                                activeItem={props.activeItem}
                                map={props.map}
                            />
                        </div>
                    </div>
                }
            </div>
        </div>

    );

}
